<template>
    <div id="goodsManagement">
        <div class="title_style"> 企业服务管理</div>
        <div class="divider"></div>
        <div class="inputStyle">
            <el-input
                    placeholder="请输入服务名称" v-model="input1" clearable class="input_style">
            </el-input>
            <el-select v-model="input2" clearable placeholder="请选择状态" class="selectStyle">
                <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
            <el-select v-model="input3" clearable placeholder="请选择服务分类">
                <el-option
                        v-for="item in options1"
                        :key="item.categoryId"
                        :label="item.categoryName"
                        :value="item.categoryId">
                </el-option>
            </el-select>
            <el-tooltip class="item" effect="dark" content="查询" placement="top">
                <span  @click="returnPage" class="search-btn"></span>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="重置" placement="top">
                <span  @click="reset" class="reset-btn"></span>
            </el-tooltip>
            <el-button class="btnNew btnAll button_style" style="margin-right: 20px" @click="addGoodsBut" :disabled="!userParks.length" v-if="$_auth('product_es_add')">添加服务</el-button>
            <el-button type="danger" class="button_style" style="margin-right: 10px" :disabled="isDisable" v-if="$_auth('product_es_delete')" @click="deleteBut1">批量删除</el-button>
        </div>
        <div>
            <el-table ref="multipleTable" :data="tableData" @selection-change="handleSelectionChange" tooltip-effect="light" class="tableV1">
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column prop="productName" label="服务名称" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column label="分类" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.categoryName">{{scope.row.categoryName}}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
              <el-table-column label="发布时间" align="left" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-if="scope.row.publishTime">{{scope.row.publishTime}}</span>
                  <span v-else style="color: #FF4064">未发布</span>
                </template>
              </el-table-column>
                <el-table-column label="状态" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span  :class="{'stateStyle': scope.row.onlineStatus == 0}">{{scope.row.onlineStatus == 1 ? '已上架' : '已下架'}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="70" align='center' fixed="right">
                    <template slot-scope="scope">
                        <el-dropdown :ref="scope.row.id">
                            <span class="iconfont icon-gengduocaozuo operation"></span>
                            <el-dropdown-menu slot="dropdown" class="group-btn" style="width: 100px">
                                <el-dropdown-item v-if="$_auth('product_es_modify') && !scope.row.publishStatus">
                                    <div size="small" style="color: #1AB394;min-width: 70px" @click="editorGoodsBut(scope.row)">编辑</div>
                                </el-dropdown-item>
                                <el-dropdown-item v-if="!scope.row.publishStatus">
                                    <div size="small" style="color: #1AB394;min-width: 70px" @click="release(scope.row.id)">发布</div>
                                </el-dropdown-item>
                                <el-dropdown-item v-if="$_auth('product_es_modify_online_status') && scope.row.publishStatus">
                                    <div size="small" style="color: #1AB394" v-if="scope.row.onlineStatus == 0" @click="stateBut(scope.row)">上架</div>
                                    <div size="small" style="color: #1AB394" v-if="scope.row.onlineStatus == 1" @click="stateBut(scope.row)">下架</div>
                                </el-dropdown-item>
                                <el-dropdown-item v-if="$_auth('product_es_delete')">
                                    <div size="small" style="color: #FF4064" @click="deleteBut(scope.row)">删除</div>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </el-table>
            <el-page :size-change="handleSizeChange" :current-change="handleCurrentChange" :page-config="pageConfig"></el-page>
            <!--删除弹框-->
            <el-dialog title="提示" :visible.sync="deleteDialog" class="delClass" width="540px" center :close-on-click-modal="false">
                <div>
                    <span v-text="'是否删除服务'"></span>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button class="btnType btnCancel buttonStyle" @click="deleteDialog = false">取 消</el-button>
                    <el-button class="btnNew btnAll" @click="deleteGoods">确 定</el-button>
                </span>
            </el-dialog>
            <!--上下架弹框-->
            <el-dialog title="提示" :visible.sync="stateDialog" class="delClass" width="540px" center :close-on-click-modal="false">
                <div>
                    <span v-text="onlineTitle"></span>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button class="btnType btnCancel buttonStyle" @click="stateDialog = false">取 消</el-button>
                    <el-button class="btnNew btnAll" @click="stateGoods">确 定</el-button>
                </span>
            </el-dialog>
          <!--发布弹框-->
          <el-dialog title="发布服务" :visible.sync="releaseDialog" class="delClass" width="540px" center :close-on-click-modal="false">
            <div>
              <div v-text="'是否发布当前服务？'"></div>
              <div v-text="'发布后将在App内展示。'"></div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="btnType btnCancel buttonStyle" @click="releaseDialog = false">取 消</el-button>
                <el-button class="btnNew btnAll" @click="confirmRelease" :loading="replayLoading">确 定</el-button>
            </span>
          </el-dialog>
        </div>
    </div>
</template>

<script>
    import * as access from '@/config/access';
    import API from '@/fetch/api'

    export default {
        data() {
            return {
                confirmId: null,
                releaseDialog: false,
                parkId: access.storage('projectId'),
                userParks: access.storage('userParks'),
                input1: "",
                input2: "",
                input3: "",
                tableData: [],
                pageConfig: {
                    pageSize: 10,
                    total: 0,
                    pageNumber: 1,
                    pageSizes: [10, 20],
                    layout: 'slot,sizes, prev, pager, next, jumper'
                },
                options: [{value: '0', label: '已下架'}, {value: '1', label: '已上架'}],
                options1: [],
                productId: "",          // 获取信息id
                deleteDialog: false,   //删除弹框
                stateDialog: false,    //上下架弹框
                isDisable: true,        //按钮
                onlineStatus: "",       //  是否启用状态
                onlineTitle: "",        //上下架提示信息
                replayLoading: false,
            }
        },
        methods: {
            getGoodsInfo() {         //获取商品列表信息\
                if(!this.parkId) return
                const val = {
                    parkId: this.parkId,
                    productName: this.input1,
                    onlineStatus: this.input2,
                    categoryId: this.input3,
                };
                API.http({
                    fullUrl: '/merchant/product/es/list/v2?pageNumber=' + this.pageConfig.pageNumber + '&pageSize=' + this.pageConfig.pageSize,
                    params: val,
                    type: "post",
                }).then(res => {
                    if (res.code == 200) {
                        this.tableData = res.data.dataList;
                        this.pageConfig.total = res.data.total
                    }
                })
            },
            getGoodsState() {     //获取商品分类
                const val = {
                    showFlag: 1,
                    projectId: this.parkId
                };
                API.http({
                    fullUrl: '/merchant/category/es/list_all/v2',
                    params: val,
                    type: "post",
                }).then(res => {
                    if (res.code === 200) {
                        this.options1 = res.data.data
                    }
                })
            },
            reset() {
                this.input1 = "";
                this.input2 = "";
                this.input3 = "";
                this.returnPage()
                this.getGoodsInfo()
            },
            handleSelectionChange(selection) {    //表单发生变化的时候触发
                if (selection.length > 0) {
                    this.isDisable = false
                } else {
                    this.isDisable = true
                }
                this.productId = "";
                let val = [];
                for (let i = 0; i < selection.length; i++) {
                    val.push(selection[i].id)
                }
                this.productId = val.join(',')
            },
            handleSizeChange(val) {
                this.pageConfig.pageNumber = 1;
                this.pageConfig.pageSize = val;
                this.getGoodsInfo()
            },
            handleCurrentChange(val) {
                this.pageConfig.pageNumber = val;
                this.getGoodsInfo()
            },
            deleteBut(item) {
                this.productId = item.id;
                this.deleteDialog = true;
            },
            deleteBut1() {
                this.deleteDialog = true;
            },
            deleteGoods() {      //删除商品信息
                const val = {
                    productId: this.productId
                };
                API.http({
                    fullUrl: '/merchant/product/es/delete',
                    params: val,
                    type: "post",
                }).then(res => {
                    if (res.code === 200) {
                        this.$notify({
                            title: '成功',
                            message: '删除成功',
                            type: 'success'
                        });
                    } else {
                        this.$notify.error({
                            title: '错误',
                            message: res.message,
                        });
                    }
                    this.getGoodsInfo();
                });
                this.productId = "";
                this.deleteDialog = false;
            },
            stateBut(item) {     //上下架按钮
                this.productId = item.id;
                if (item.onlineStatus == 0) {
                    this.onlineStatus = 1;
                    this.onlineTitle = "是否上架该服务"
                } else {
                    this.onlineStatus = 0;
                    this.onlineTitle = "是否下架该服务"
                }
                this.stateDialog = true
            },
            stateGoods() {     //  上/下架商品
                const val = {
                    onlineStatus: this.onlineStatus,
                    productId: this.productId
                };
                API.http({
                    fullUrl: '/merchant/product/es/modify/online_status/v2',
                    params: val,
                    type: "post",
                }).then(res => {
                    if (res.code === 200) {
                        this.$notify({
                            title: '成功',
                            message: '修改成功',
                            type: 'success'
                        });
                    } else {
                        this.$notify.error({
                            title: '错误',
                            message: res.message,
                        });
                    }
                    this.getGoodsInfo();
                });
                this.productId = "";
                this.stateDialog = false;
            },
            returnPage() {
                this.handleCurrentChange(1)
            },
            addGoodsBut() {    //跳转添加页面
                this.$router.push({name: 'addGoods'})
            },
            editorGoodsBut(item) {    //跳转编辑页面
                this.$router.push({path: '/goodsManage/addGoods', query: {productId: item.id}})
            },
            release(id){   //发布
                this.releaseDialog = true;
                this.confirmId = id;
            },
            confirmRelease(){
                this.replayLoading = true;
                API.http({ fullUrl: '/merchant/product/es/modify/publish_status', type: "post",
                    params: { productId: this.confirmId }
                }).then(res => {
                    if (res.code == 200) {
                        this.replayLoading = false;
                        this.$notify({
                            title: '',
                            message: '发布成功',
                            type: 'success'
                        });
                        this.getGoodsInfo();
                        this.releaseDialog = false;
                        return;
                    }
                    this.replayLoading = false;
                    this.$notify.error({
                        title: '发布失败',
                        message: res.message,
                    });
                });
            }
        },
        created() {
            this.getGoodsInfo();
            this.getGoodsState();
        }
    }
</script>

<style lang="scss" >
    #goodsManagement {
        background-color: white;

        .divider {
            width: 100%;
            height: 1px;
            background-color: #E7EAEC;
        }

        .input_style {
            width: 220px;
        }

        .paging_style {
            color: #606266;
            font-size: 12px;
        }

        .font_style {
            margin-left: 10px;
            font-size: 35px;
            color: #76838E;
            position: relative;
            top: 9px;
        }

        .title_style {
            font-size: 18px;
            color: #1AB394;
            font-weight: 500;
            padding: 10px 0 10px 20px;
        }

        .button_style {
            position: relative;
            top: 14px;
            float: right;
            height: 36px;
            width: 80px;
        }

        .buttonStyle{
            width: 100px;
        }

        .tableStyle {
            margin-bottom: 10px;
        }

        .operation {
            color: #BFC4C7;
            font-size: 14px
        }

        .stateStyle{
            color: #C2C8CC;
        }

        .selectStyle{
            margin-left: 10px;
            margin-right: 10px
        }

        .search-btn{
            position: relative;
            top: 13px;
            left: 5px;
        }

        .reset-btn{
            position: relative;
            top: 13px;
            left: 5px;
        }
    }
</style>


<style lang="scss">
    #goodsManagement {
        .inputStyle {
            margin: 7px 0 20px 20px;

            .el-input--small .el-input__inner {
                height: 36px;
                line-height: 36px;
            }

            .el-input__inner:focus{
                border-color: #1ab394;
            }
        }

        .tableV1{
            margin-top: -1px;
        }
    }
</style>
